// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var ReadOnly = function (x) {
    return x;
};
var value = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Specular_Ref.write(Effect_Class.monadEffectEffect)(v1.value)(v));
    };
};
var queryReadOnly = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return function (v1) {
                return Restaumatic_Form_Final.makeFinalV(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Bifunctor.bimap(Data_Validation_Semigroup.bifunctorV)(Restaumatic_Form.tagErrors(v1.name))(Type_Equality.from(dictTypeEquals)))((function (v2) {
                    return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(v2)(Restaumatic_Form_Final.unFinalV);
                })(Specular_Ref.value(v1.value))));
            };
        }
    };
};
var makeEmptyReadOnly = {
    makeEmptyImpl: function (opts) {
        return function __do() {
            var value_ = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.makeFinalV(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.internalError("ReadOnly not defined")))))();
            return {
                name: opts.name,
                value: value_
            };
        };
    }
};
var errors = function (v) {
    var getErrors = (function () {
        var $16 = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
            return v1.message;
        });
        var $17 = Data_Array.filter((function () {
            var $22 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
            return function ($23) {
                return $22((function (v1) {
                    return v1.internal;
                })($23));
            };
        })());
        var $18 = Data_Maybe.fromMaybe([  ]);
        var $19 = Data_Map_Internal.lookup(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(new Data_Maybe.Just(v.name));
        var $20 = Data_Newtype.unwrap();
        return function ($21) {
            return $16($17($18($19($20($21)))));
        };
    })();
    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(getErrors)(function (v1) {
        return [  ];
    }))(Restaumatic_Form_Final.unFinalV(Restaumatic_Form.query(queryReadOnly(Type_Equality.refl))(v)));
};
var dumpStateReadOnly = {
    dumpState: function (v) {
        return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil))({}));
    }
};
var addContextReadOnly = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
export {
    ReadOnly,
    value,
    errors,
    makeEmptyReadOnly,
    queryReadOnly,
    addContextReadOnly,
    dumpStateReadOnly
};
//# sourceMappingURL=index.js.map
